// extracted by mini-css-extract-plugin
module.exports = {"middleAd":"SpotPageMiddleAd_middleAd__Vm5U3"};